export default __webpack_public_path__ + "static/media/kts_ addressbook.82a47398.png";